/* eslint-disable react/no-deprecated */
import React from 'react';
import Style from './index.less';
import { ActionType } from '../../../../editor/src/js/constants/common-action-type';
import Menu from '@tencent/dui/lib/components/Menu';
import {
    CROP_WH_1_1,
    CROP_WH_2_3,
    CROP_WH_3_2,
    CROP_WH_3_4,
    CROP_WH_3_5,
    CROP_WH_4_3,
    CROP_WH_4_5,
    CROP_WH_5_3,
    CROP_WH_5_4,
    CROP_WH_16_9,
    CROP_WH_16_10,
} from '../../../../editor/src/img/pageIndex/index';

export const wh = [
    { id: ActionType.TAILOR_PIC_WH_1_1, title: '1:1', icon: CROP_WH_1_1 },
    { id: ActionType.DIVIDER },
    { id: ActionType.TAILOR_PIC_WH_2_3, title: '2:3', icon: CROP_WH_2_3 },
    { id: ActionType.TAILOR_PIC_WH_3_4, title: '3:4', icon: CROP_WH_3_4 },
    { id: ActionType.TAILOR_PIC_WH_3_5, title: '3:5', icon: CROP_WH_3_5 },
    { id: ActionType.TAILOR_PIC_WH_4_5, title: '4:5', icon: CROP_WH_4_5 },
    { id: ActionType.DIVIDER },
    { id: ActionType.TAILOR_PIC_WH_3_2, title: '3:2', icon: CROP_WH_3_2 },
    { id: ActionType.TAILOR_PIC_WH_4_3, title: '4:3', icon: CROP_WH_4_3 },
    { id: ActionType.TAILOR_PIC_WH_5_3, title: '5:3', icon: CROP_WH_5_3 },
    { id: ActionType.TAILOR_PIC_WH_5_4, title: '5:4', icon: CROP_WH_5_4 },
    { id: ActionType.TAILOR_PIC_WH_16_9, title: '16:9', icon: CROP_WH_16_9 },
    { id: ActionType.TAILOR_PIC_WH_16_10, title: '16:10', icon: CROP_WH_16_10 },
];

interface SubMenuProps {
    handleMenuClick: (item) => void;
    id?: string;
    border: any;
}

export default class SubMenu extends React.Component<SubMenuProps> {
    public constructor(props, context) {
        super(props, context);
    }

    public render() {
        const list = wh;
        const itemStyle = { height: '32px', padding: '0px 12px' };
        return (
            <ul className={Style['border-menu']}>
                {
                    list.map((item, index) => (
                        item.id === ActionType.DIVIDER
                            ? <li key={index} className={Style.divider} />
                            : <Menu.Item key={index} style={itemStyle}>
                                <div key={index} className={Style.menuItemContainer}
                                    onMouseDown={() => this.handleItemClick(item)}>
                                    <img src={item.icon} className={Style.imgStyle} />
                                    <div className={Style.imageAndTextItemTitle}>{item.title}</div>
                                </div>
                            </Menu.Item>
                    ))}
            </ul>
        );
    }

    private handleItemClick = (item) => {
        this.props.handleMenuClick(item);
    };
}
